import { Suspense, lazy, useEffect, useRef, useState } from "react";
import type { MapMarker } from "./USMarketsMap.types";

const USMarketsMap = lazy(() =>
  import("./USMarketsMap").then((m) => ({ default: m.USMarketsMap })),
);

function Placeholder() {
  return (
    <div className="w-full">
      <div
        className="w-full bg-surface border border-border"
        style={{ aspectRatio: "980 / 560" }}
      />
      <p className="mt-4 text-xs text-foreground/60 text-center">
        Hover a pin to preview · click to visit that market
      </p>
    </div>
  );
}

export function LazyUSMarketsMap({ markers }: { markers: MapMarker[] }) {
  const ref = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || show) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setShow(true);
          io.disconnect();
        }
      },
      { rootMargin: "300px" },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [show]);

  return (
    <div ref={ref}>
      {show ? (
        <Suspense fallback={<Placeholder />}>
          <USMarketsMap markers={markers} />
        </Suspense>
      ) : (
        <Placeholder />
      )}
    </div>
  );
}
